
function PlanetInfoPanel({ planet, onClose, position }) {
  if (!planet) return null;
  
  console.log('Rendering PlanetInfoPanel:', planet.name, position); 
  
  return (
    <div style={{
      position: 'fixed', 
      top: Math.max(20, Math.min(position.y - 20, window.innerHeight - 400)), 
      left: Math.max(20, Math.min(position.x - 175, window.innerWidth - 350)), 
      background: 'rgba(0,0,0,0.95)',
      color: 'white',
      padding: '20px',
      borderRadius: '12px',
      minWidth: '280px',
      maxWidth: '350px',
      backdropFilter: 'blur(15px)',
      border: '2px solid rgba(255,255,255,0.3)', 
      zIndex: 10000, 
      boxShadow: '0 8px 32px rgba(0,0,0,0.8)',
      pointerEvents: 'auto'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h3 style={{ margin: 0, color: planet.color, fontSize: '20px', textShadow: '0 0 10px currentColor' }}>{planet.name}</h3>
        <button
          onClick={onClose}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            fontSize: '18px',
            cursor: 'pointer',
            padding: '4px 8px',
            borderRadius: '4px',
            minWidth: '28px',
            minHeight: '28px'
          }}
        >
          ×
        </button>
      </div>
      
      <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
        <div style={{ marginBottom: '10px', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <strong style={{ color: '#FFD700' }}>Diameter:</strong> {planet.info.diameter}
        </div>
        <div style={{ marginBottom: '10px', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <strong style={{ color: '#FFD700' }}>Distance from Sun:</strong> {planet.info.distanceFromSun}
        </div>
        <div style={{ marginBottom: '10px', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <strong style={{ color: '#FFD700' }}>Day Length:</strong> {planet.info.dayLength}
        </div>
        <div style={{ marginBottom: '10px', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <strong style={{ color: '#FFD700' }}>Year Length:</strong> {planet.info.yearLength}
        </div>
        <div style={{ marginBottom: '10px', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <strong style={{ color: '#FFD700' }}>Moons:</strong> {planet.info.moons}
        </div>
        <div style={{ marginBottom: '10px', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <strong style={{ color: '#FFD700' }}>Temperature:</strong> {planet.info.temperature}
        </div>
        <div style={{ padding: '5px 0' }}>
          <strong style={{ color: '#FFD700' }}>Composition:</strong> {planet.info.composition}
        </div>
      </div>
    </div>
  );
}

export default PlanetInfoPanel